var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLevels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 175,
    height: 46,
    viewBox: "0 0 175 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1989",
    "data-name": "Group 1989",
    transform: "translate(-888 -2045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1926",
    "data-name": "Group 1926",
    transform: "translate(454 -1522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5",
    "data-name": "Polygon 5",
    d: "M22.168,7.521a5,5,0,0,1,8.665,0L48.682,38.5A5,5,0,0,1,44.349,46H8.651a5,5,0,0,1-4.332-7.5Z",
    transform: "translate(487 3613) rotate(180)",
    fill: "#fc6405"
  }), /*#__PURE__*/React.createElement("text", {
    id: "R",
    transform: "translate(443.5 3569)",
    fill: "#fafaf2",
    fontSize: 22,
    fontFamily: "BoucherieBlock, Boucherie Block"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11.588,
    y: 23
  }, "R"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1986",
    "data-name": "Group 1986",
    transform: "translate(515 -1522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5-2",
    "data-name": "Polygon 5",
    d: "M22.168,7.521a5,5,0,0,1,8.665,0L48.682,38.5A5,5,0,0,1,44.349,46H8.651a5,5,0,0,1-4.332-7.5Z",
    transform: "translate(487 3613) rotate(180)",
    fill: "#fc6405"
  }), /*#__PURE__*/React.createElement("text", {
    id: "E",
    transform: "translate(443.5 3569)",
    fill: "#fafaf2",
    fontSize: 22,
    fontFamily: "BoucherieBlock, Boucherie Block"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12.138,
    y: 23
  }, "E"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1987",
    "data-name": "Group 1987",
    transform: "translate(576 -1522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5-3",
    "data-name": "Polygon 5",
    d: "M22.168,7.521a5,5,0,0,1,8.665,0L48.682,38.5A5,5,0,0,1,44.349,46H8.651a5,5,0,0,1-4.332-7.5Z",
    transform: "translate(487 3613) rotate(180)",
    fill: "#fc6405"
  }), /*#__PURE__*/React.createElement("text", {
    id: "L",
    transform: "translate(443.5 3569)",
    fill: "#fafaf2",
    fontSize: 22,
    fontFamily: "BoucherieBlock, Boucherie Block"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12.468,
    y: 23
  }, "L"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevels);
export default __webpack_public_path__ + "static/media/levels.443165097a1362bc957b432cad327000.svg";
export { ForwardRef as ReactComponent };